import React from "react";
import {ReceiptState} from "../interfaces/ReceiptState";
import Toast from "../../../../../../utility/toast";
import AppSettingController from "../../../../../Main/controller/AppSettingController";
import i18n from "../../../../../../i18n";

export default class ReceiptController {
    protected state: ReceiptState;
    protected setState: React.Dispatch<React.SetStateAction<ReceiptState>>;

    constructor(state: ReceiptState, setState: React.Dispatch<React.SetStateAction<ReceiptState>>) {
        this.state = state;
        this.setState = setState;
    }

    saveFirstReceipt(e: React.FormEvent<HTMLElement>) {
        e.preventDefault()
        this.updateState({error: false})

        if (this.state.value <= 0 || !this.state.value) {
            Toast.error(i18n.t("toast.saveFirstReceiptFailed"))
            return this.updateState({error: true, message: i18n.t("setting.error.invalidReceiptNumber")})
        }

        AppSettingController.changeReceiptBasicNumber(this.state.value)
        Toast.success(i18n.t("toast.receiptChangeSuccess"))
    }

    receiptInput(e: React.ChangeEvent<HTMLInputElement>) {
        this.updateState({value: e.currentTarget.value})
    }

    private updateState(state: object) {
        const newState = {...this.state, ...state};
        this.state = newState;
        this.setState(newState)
    }
}
